import styled from "styled-components";

const DropDownRadioBundle = styled.label`
`;

export default DropDownRadioBundle;